<div class="view-container">
  <mat-card class="user-create-card">
    <div class="user-create-card__header">
      <div class="user-create-card__title-row">
        <div class="user-create-card__icon">
          <mat-icon>person_add</mat-icon>
        </div>
        <div>
          <h1 class="user-create-card__title">New user</h1>
          <p class="user-create-card__subtitle">Create a portal user and assign roles</p>
        </div>
      </div>
    </div>

    <form autocomplete="none" [formGroup]="createUserForm" class="user-create-card__form" (ngSubmit)="save()">
      <div class="row g-2">
        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Full name</mat-label>
              <input formControlName="name" type="text" matInput />
              @if (createUserForm.get('name')?.invalid) {
                <mat-error>Full name is required</mat-error>
              }
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input formControlName="email" type="email" matInput />
              @if (createUserForm.get('email')?.invalid) {
                <mat-error>Email is required</mat-error>
              }
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline" floatLabel="always" class="user-create-card__company-field">
              <mat-label>Company or individual</mat-label>
              <div class="user-create-card__company-row">
                <mat-button-toggle-group
                  name="linkType"
                  [value]="linkType"
                  (change)="setLinkType($event.value)"
                >
                  <mat-button-toggle value="company">Company</mat-button-toggle>
                  <mat-button-toggle value="individual">Individual</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-chip-grid #companyList aria-label="Company or individual selection" class="user-create-card__company-search">
                  @for (company of companies; track company) {
                    <mat-chip-row [removable]="removable" (removed)="removeCompany(company)">
                      {{ company }}
                      @if (removable) {
                        <button matChipRemove type="button">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      }
                    </mat-chip-row>
                  }
                  @if (linkType === 'company') {
                    <input
                      #companyInput
                      [placeholder]="companies.length > 0 ? '' : 'Search companies...'"
                      formControlName="companySearch"
                      [matAutocomplete]="companyAuto"
                      [matChipInputFor]="companyList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addCompany($event)"
                      [disabled]="isCompanySelected()"
                    />
                  }
                  @if (linkType === 'individual') {
                    <input
                      #individualInput
                      [placeholder]="companies.length > 0 ? '' : 'Search individuals...'"
                      formControlName="individualSearch"
                      [matAutocomplete]="individualAuto"
                      [matChipInputFor]="companyList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="addCompany($event)"
                      [disabled]="isCompanySelected()"
                    />
                  }
                </mat-chip-grid>
              </div>
              <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="selectedCompany($event)">
                @for (company of filteredCompanies | async; track company) {
                  <mat-option [value]="company">{{ company.name }}</mat-option>
                }
              </mat-autocomplete>
              <mat-autocomplete #individualAuto="matAutocomplete" (optionSelected)="selectedIndividual($event)">
                @for (ind of filteredIndividuals | async; track ind) {
                  <mat-option [value]="ind">
                    {{ (ind.title ? ind.title + ' ' : '') + ind.first_name + ' ' + ind.last_name }}
                    ({{ getIndividualTypeLabel(ind) }})
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </p>
        </div>

        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Phone number</mat-label>
              <input formControlName="phone_number" type="text" matInput />
              @if (createUserForm.get('phone_number')?.invalid) {
                <mat-error>Phone number is invalid</mat-error>
              }
              <mat-hint>Phone number should start with +27 code</mat-hint>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Roles</mat-label>
              <mat-chip-grid #roleList aria-label="Role selection">
                @for (role of roles; track role) {
                  <mat-chip-row [removable]="removable" (removed)="remove(role)">
                    {{ role }}
                    @if (removable) {
                      <button matChipRemove type="button">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    }
                  </mat-chip-row>
                }
                <input
                  #roleInput
                  placeholder="Add role..."
                  formControlName="roles"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="roleList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)"
                />
              </mat-chip-grid>
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              @for (role of filteredRoles | async; track role) {
                <mat-option [value]="role">{{ role }}</mat-option>
              }
            </mat-autocomplete>
          </p>
        </div>
      </div>

      <div class="user-create-card__footer">
        <button
          type="submit"
          mat-flat-button
          color="primary"
          class="user-create-card__btn--primary"
          [disabled]="roles.length === 0 || createUserForm.invalid"
        >
          <mat-icon>save</mat-icon>
          Save
        </button>
      </div>
    </form>
  </mat-card>
</div>
